import React from 'react';

type Props = {}

export const FormattedDate = (epochTimestamp: number) => {
    const date = new Date(epochTimestamp);
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
};

export const FormattedDateOnly = (datetime: string) => {
    const dateObject = new Date(datetime);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    };
    return dateObject.toLocaleString('en-US', options);
  };

  
export const FormattedDateTime = (
  datetime: string,
  timeZone?: string // optional
) => {
  // Ensure UTC
  const dateObject = new Date(
    datetime.endsWith('Z') ? datetime : datetime + 'Z'
  );

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone: timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  return dateObject.toLocaleString('en-US', options);
};